/* Factory Store
   Fuerza el layout mobile del header nativo debajo de 990px.

   Horizon decide el layout del header con el atributo data-menu-style:
     'menu'   -> grilla de escritorio (logo / menu / acciones)
     'drawer' -> grilla mobile (hamburguesa, logo centrado, acciones)

   El script inline de layout/theme.liquid lo resuelve mirando si el
   dispositivo es tactil, NO el ancho de la ventana. En un notebook
   achicado a 850px daba 'menu', y el header se veia con layout de
   escritorio en un ancho donde ya deberia verse como mobile.

   Aca lo atamos al mismo breakpoint de 990px que usan
   assets/factory-mobile.css y snippets/factory-mega-menu.liquid.
   Oct 2026: se aplica tambien en el cambio de breakpoint (matchMedia) y
   se vuelve a imponer si el tema cambia el atributo, para que al achicar
   la ventana nunca quede un header "a medio camino". */
(function () {
  var BREAKPOINT = 990;
  var mq = window.matchMedia('(max-width: ' + (BREAKPOINT - 1) + 'px)');

  function resolve(header) {
    if (mq.matches) return 'drawer';

    // Arriba de 990 respetamos la logica original del tema.
    var isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
    var overflowList = header.querySelector('overflow-list');
    var hasReachedMinimum = overflowList && overflowList.hasAttribute('minimum-reached');
    return isTouchDevice || hasReachedMinimum ? 'drawer' : 'menu';
  }

  var watching = false;
  function apply() {
    var header = document.querySelector('#header-component');
    if (!header) return;

    var next = resolve(header);
    if (header.dataset.menuStyle !== next) {
      header.dataset.menuStyle = next;
    }

    if (!watching) {
      watching = true;
      new MutationObserver(function () {
        if (mq.matches && header.dataset.menuStyle !== 'drawer') header.dataset.menuStyle = 'drawer';
      }).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
    }
  }

  apply();
  window.addEventListener('resize', apply, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  }
})();